module.exports = __webpack_public_path__ + "static/img/mine2.84b4010.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mine2.jpg
// module id = nej9
// module chunks = 1